export enum OrganizationType {
  Customer = 'CUSTOMER',
  Partner = 'PARTNER'
}
